import SideBarTool from "@/commons/components/side-bar-tool";
import { Radio, Select, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PMaterial } from "@/commons/interface/speccommon/material";
import { MAJOR } from "@/commons/constants/major";
import { getMaterialsByprojectUuid } from "@/api/spec-common/material";
import { findLayersInProjectUuid, saveLayer } from "@/api/geometry/layer";
import genUUID from "@/commons/utils/gen-uuid";
import { Layer } from "@/commons/interface/geometry/layer";
import { LineType, Polygon } from "pytha";
import { graphicStore } from "@/commons/store/graphic-store";
import { ReactComponent as AssembleBlackSvg } from "@/commons/icons/panel-icon/assemble-black.svg";
import TnMessage from "@/commons/widget/message";
import { TunnelEnum, TunnelType } from "@/commons/enums/tunnel-type";
import { HVAC_SIGNAL } from "@/passets/hvac-engine/enums/hvac-signal";
import { HVAC_SUB_CONTROL } from "@/passets/hvac-engine/enums/hvac-sub-control";
import { HVAC_CTRL_TYPE } from "@/passets/hvac-engine/enums/hvac-control-type";
import { LayerType } from "@/commons/enums/layer-type";
import TnInput from "@/commons/widget/input/tn-input";


export default function FireTunnelBlockPanel() {
    const { projectUuid, modelUuid } = useParams();
    const [materials, setMaterials] = useState<PMaterial[]>([]); // 材料列表
    const [selMaterial, setSelMaterial] = useState<PMaterial>(null);
    const [diameter, setDiameter] = useState<number>(null);    // 管径
    const [length, setLength] = useState<number>(null);    // 长度
    const [width, setWidth] = useState<number>(null);
    const [thickness, setThickness] = useState<number>(null);
    const [type, setType] = useState<number>(TunnelEnum.TUBE); // 截面类型

    useEffect(() => {
        if (!projectUuid) return;
        getMaterialsByprojectUuid(projectUuid, MAJOR.HVAC).then(res => {
            if (res.status == 200) {
                let materials = res.data || [];
                setMaterials(materials);
            }
        }).catch(() => {
            message.error("获得材料列表失败")
        })
    }, [projectUuid])

    const onMaterialChange = (uuid: string) => {
        let material = materials.find(item => item.uuid == uuid);
        setSelMaterial(material);
    }

    // 点击了布置按钮
    const assemble = () => {
        if (selMaterial == null) {
            TnMessage.error("请选择材料");
            return;
        }
        if (!thickness) {
            message.warning("请输入壁厚");
            return;
        }
        if (type == TunnelEnum.RECTANGLE) {
            // 矩形管
            if (!length) {
                message.warning("请输入长度");
                return;
            }
            if (!width) {
                message.warning("请输入宽度");
                return;
            }
            if (length / 2 < thickness || width / 2 < thickness) {
                message.warning("壁厚不能大于 1/2 长度或宽度!");
                return;
            }
        } else if (type == TunnelEnum.TUBE) {
            // 圆管
            if (!diameter) {
                message.warning("请输入管径");
                return;
            }
            if (thickness > diameter / 2) {
                message.warning("壁厚不能大于 1/2 管径!");
                return;
            }
        }
        let section;
        let tempDiameter = null;
        if (type == TunnelEnum.RECTANGLE) {
            // 矩形管
            section = {
                polygonType: '箱形',
                paramIn: {
                    b: width / 1000,
                    h: length / 1000,
                    t_f1: thickness / 1000,
                    t_f2: thickness / 1000,
                    t_w1: thickness / 1000,
                    t_w2: thickness / 1000,
                }
            }
            tempDiameter = width > length ? width : length
        } else if (type == TunnelEnum.TUBE) {
            // 圆管
            section = {
                polygonType: '圆管',
                paramIn: {
                    d: diameter / 1000,
                    t: thickness / 1000,
                }
            }
            tempDiameter = diameter;
        }
        if (!section) {
            message.warning("截面信息加载失败");
            return;
        }
        findLayersInProjectUuid(projectUuid, modelUuid).then(res => {
            let layers: Layer[] = res.data || [];
            let componentLayer = layers?.find(item => item?.type === LayerType.FIRE_TUNNEL);
            if (!!componentLayer) {
                // 存在一个图层为构件图层，绘制的图元都在该图层中
                handleAssemble(section, tempDiameter, componentLayer.uuid);
            } else {
                // 不存在一个图层为构件图层，新建一个图层作为构件图层，绘制的图元都在该图层中
                let uuid = genUUID();
                let newLayer: Layer = {
                    uuid: uuid,
                    name: "消防管道",
                    color: "#ff0000",
                    lineWidth: 0.25,
                    lineType: LineType.BASE_LINE,
                    lock: false,
                    hidden: false,
                    projectUuid: projectUuid,
                    originLayer: false,
                    type: LayerType.FIRE_TUNNEL,
                };
                saveLayer(newLayer, projectUuid, modelUuid).then(res => {
                    if (res.status === 200) {
                        graphicStore.context.layerContext.addLayer(newLayer);
                        handleAssemble(section, tempDiameter, newLayer.uuid);
                    }
                }).catch(err => {
                    message.error("无法置为构件图层");
                    console.log(err);
                })
            }
        })
    }

    const handleAssemble = (section, tempDiameter, layerUuid: string) => {
        let data = {
            type: type,
            length: length,
            width: width,
            diameter: tempDiameter,
            thickness: thickness,
            materialUuid: selMaterial.uuid,
            offset: 0,
            layerUuid: layerUuid,
        }
        if (!graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl
            || graphicStore.extraContext.getCurrentViewEditor().cmdControl.currentControl.id !== HVAC_CTRL_TYPE.ADD_HVAC_TUNNEL) {
            // 激活布置构件的二级控制器
            graphicStore.extraContext.getCurrentViewEditor().cmdControl.activateSubCommandControl(HVAC_SUB_CONTROL.ADDHVACTUNNELCONTROL.name);

        }
        let polygons: Polygon[] = graphicStore.extraContext.ToolContext.getPolygonBySection(section);
        let bottomFace = polygons[0];
        graphicStore.extraContext.listeners.getSignal(HVAC_SIGNAL.initHvacTunnelControl).dispatch({ ...data, bottomFace: bottomFace });
    }

    return (
        <div className="side-bar-main">
            <SideBarTool
                activeBtnList={[]}
            />
            <div className="body">
                <div className="title">
                    消防管道
                </div>
                <div className="detail structure-beam-panel">
                    <div className="row compact">
                        <div className="label">材料:</div>
                        <Select
                            size='small'
                            className="select-box"
                            placeholder='材料'
                            onChange={onMaterialChange}
                        >
                            {materials.map((item, index) => (
                                <Select.Option key={index} label={item?.name} value={item?.uuid}>
                                    {item?.name || ''}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div className="row compact">
                        <Radio.Group style={{ width: '100%', display: 'flex', flexDirection: 'row', marginBottom: '4px' }}
                            onChange={(e) => setType(e.target.value)}
                            value={type}>
                            {Object.keys(TunnelType).map((item, index) => (
                                <Radio value={TunnelType[item]?.value} key={index}>
                                    {TunnelType[item]?.label || ''}
                                </Radio>
                            ))}
                        </Radio.Group>
                    </div>
                    {type === TunnelType.RECTANGLE.value &&
                        <div className="row compact">
                            <div className="label">长度(mm):</div>
                            <TnInput
                                size='small'
                                value={length}
                                className="input-box"
                                placeholder='长度(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setLength(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setLength(null);
                                        } else {
                                            setLength(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {type === TunnelType.RECTANGLE.value &&
                        <div className="row compact">
                            <div className="label">宽度(mm):</div>
                            <TnInput
                                size='small'
                                value={width}
                                className="input-box"
                                placeholder='宽度(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setWidth(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setWidth(null);
                                        } else {
                                            setWidth(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    {type === TunnelType.TUBE.value &&
                        <div className="row compact">
                            <div className="label">管径(mm):</div>
                            <TnInput
                                size='small'
                                value={diameter}
                                className="input-box"
                                placeholder='管径(mm)'
                                onTextChange={(value) => {
                                    if (!isNaN(parseInt(value))) {
                                        setDiameter(parseInt(value));
                                    } else {
                                        if (value == '') {
                                            setDiameter(null);
                                        } else {
                                            setDiameter(0);
                                        }
                                    }
                                }}
                            />
                        </div>}
                    <div className="row compact">
                        <div className="label">壁厚(mm):</div>
                        <TnInput
                            size='small'
                            value={thickness}
                            className="input-box"
                            placeholder='壁厚(mm)'
                            onTextChange={(value) => {
                                if (!isNaN(parseInt(value))) {
                                    setThickness(parseInt(value));
                                } else {
                                    if (value == '') {
                                        setThickness(null);
                                    } else {
                                        setThickness(0);
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className='bottom-footer'>
                        <div className="ope-btn">
                            <div className="insert-button" onClick={assemble}>
                                <div className="icon"><AssembleBlackSvg className="icon-svg" /></div>
                                <div className="text">布置</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}